import { Base, Buttons, ColorButton, Divider, Flex, ProgressBar, Text } from '@bitrise/bitkit';
import React, { useContext, FunctionComponent } from 'react';
import useOnboarding from './useOnboarding';
import { URLStateContext } from '../URLState/URLState';
import ProgressStage from './ProgressStage';

const OnboardingProgress: FunctionComponent = () => {
  const { countdown, progress, stage } = useOnboarding();
  const { push } = useContext(URLStateContext);

  return (
    <Flex>
      {progress >= 1 && (
        <Text margin="x2" textColor="green-2">
          Hurray, setup complete!
        </Text>
      )}

      <Text config="8" margin="x3" textColor="grape-1">
        The app might look a little empty until the SDK sends back more data from more users.
      </Text>

      <Text align="end" config="8" margin="x1" textColor="gray-5">
        {progress >= 1 ? 'Complete' : countdown}
      </Text>

      <ProgressBar
        backgroundColor="grape-4"
        borderRadius="x2"
        foregroundColor="aqua-3"
        height="6px"
        progress={progress}
        stripeColor="grape-5"
      />

      <Base margin="x6">
        <ProgressStage name="Detection" stage={stage} />
        <Divider color="eggplant" margin="x3" width="1px" />
        <ProgressStage name="Transmission" stage={stage} />
        <Divider color="eggplant" margin="x3" width="1px" />
        <ProgressStage name="Processing" stage={stage} />
        <Divider color="eggplant" margin="x3" width="1px" />
        <ProgressStage name="Storage" stage={stage} />
        <Divider color="eggplant" margin="x3" width="1px" />
      </Base>

      <Buttons alignChildrenHorizontal="middle">
        <ColorButton color="white" onClick={() => push('/o/getting-started')} size="small">
          Back to Getting Started
        </ColorButton>
      </Buttons>
    </Flex>
  );
};

export default OnboardingProgress;
